// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2bzPQ","fileBtn":"File_fileBtn__3vbtr","closeBtn":"File_closeBtn__f6xVx","fileSelected":"File_fileSelected__3XjYz","disabled":"File_disabled__2qB6B"};